// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rr7y","col":"styles_col__fa5lB"};